import React, { useState } from 'react';

function ClasificadorLectura({ onSelectionChange, handlerTipo, handlerTematica, handlerArea, handlerTipoPreguntas,
  handlerTipoMaterialEducativo,handlerLinkREPO,handlerLinkOFICIAL,handlerTipoSelectorNivelProfundidad,
}) {

  const [tipo, setTipo] = useState('');
  const [tipoPreguntas, setTipoPreguntas] = useState('');
  const [tematica, setTematica] = useState('');
  const [area, setArea] = useState('');

  const [tipoMaterialEducativo, setTipoMaterialEducativo] = useState('');
  const [linkREPO, setLinkREPO] = useState('');
  const [linkOFICIAL, setLinkOFICIAL] = useState('');
  const [tipoSelectorNivelProfundidad, setTipoSelectorNivelProfundidad] = useState('');

  var targetTipo = tipo
  var targetTipoPreguntas = tipoPreguntas
  var targetTematica = tematica
  var targetArea = area
  var targetLinkMaterialREPO = linkREPO
  var targetLinkMaterialOFICIAL = linkOFICIAL
  var targetTipoMaterialEducativo = tipoMaterialEducativo
  var targetTipoSelectorNivelProfundidad = tipoSelectorNivelProfundidad

  const handleTipoChange = (event) => {
    const selectedTipo = event.target.value;
    targetTipo = selectedTipo
    setTipo(selectedTipo);

    handlerTipo(targetTipo)
  }
  const handleTipoPreguntasChange = (event) => {
    const selectedTipoPreguntas = event.target.value;
    targetTipoPreguntas = selectedTipoPreguntas
    setTipoPreguntas(selectedTipoPreguntas);

    handlerTipoPreguntas(targetTipoPreguntas)
  }
  const handleTematicaChange = (event) => {
    const selectedTematica = event.target.value;
    targetTematica = selectedTematica
    setTematica(selectedTematica);

    handlerTematica(targetTematica)
  }

  const handleAreaChange = (event) => {
    const selectedArea = event.target.value;
    targetArea = selectedArea
    setArea(selectedArea);

    handlerArea(targetArea)
  }

  const handleLinkOficialChange = (event) => {
    targetLinkMaterialOFICIAL = event.target.value
    setLinkOFICIAL(targetLinkMaterialOFICIAL);
    
    handlerLinkOFICIAL(targetLinkMaterialOFICIAL)
  }
  const handleLinkRepoChange = (event) => {
    targetLinkMaterialREPO = event.target.value
    setLinkREPO(targetLinkMaterialREPO);
    
    handlerLinkREPO(targetLinkMaterialREPO)
  }

  const handleTipoMaterialEducativo = (event) => {
    targetTipoMaterialEducativo = event.target.value;
    setTipoMaterialEducativo(targetTipoMaterialEducativo);
    
    handlerTipoMaterialEducativo(targetTipoMaterialEducativo)
  }

  const handleTipoSelectorNivelProfundidadChange = (event) => {
    targetTipoSelectorNivelProfundidad = event.target.value;
    setTipoSelectorNivelProfundidad(targetTipoSelectorNivelProfundidad);
    
    handlerTipoSelectorNivelProfundidad(targetTipoSelectorNivelProfundidad)
  }

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-6">
            <label htmlFor="tematicaSelector"  >Temática</label>
            <input id="tematicaSelector" className="form-control" placeholder="#tema,#curso"  value={targetTematica} onChange={handleTematicaChange} >
            </input>
        </div>
        
        <div className="col-md-6">
            <label htmlFor="tipoSelector">Categoría:</label>
            <select id="tipoSelector" className="form-control" value={targetTipo} onChange={handleTipoChange} >
                <option value="#unclasified">Tipo de Lectura</option>
                <option value="instructivo">Instructivo</option>
                <option value="narrativo">Narrativo</option>
                <option value="descriptivo">Descriptivo</option>
                <option value="argumentativo">Argumentativo</option>
                <option value="mixto">Mixto</option>
            </select>
        </div>

        <div className="col-md-6">
            <label htmlFor="areaSelector">Área:</label>
            <select id="areaSelector" className="form-control" value={targetArea} onChange={handleAreaChange} >
                <option value="#unclasified">Asignatura</option>
                <option value="comunicacion">Área de Comunicación</option>
                <option value="matematica">Área de Matemática</option>
                <option value="adpcc">Área de Desarrollo personal, ciudadanía y cívica </option>
                <option value="acc">Área de Ciencias sociales</option>
                <option value="aept">Área de Educación para el trabajo</option>
                <option value="arteycultura">Área de Arte y cultura</option>
                <option value="ingles">Área de Inglés como lengua extranjera</option>
                <option value="cienciatecnologia">Área de Ciencia y tecnología</option>
                <option value="religion">Área de Educación religiosa</option>
                <option value="acomptransversales">Área de Competencias transversales</option>
                <option value="--">--</option>
                <option value="personalsocial">Área de Personal Social </option>
                <option value="cienciayambiente">Área de Ciencia y Ambiente.</option>
                <option value="educacionfisica">Área de Educación Física</option>
                <option value="acastellano">Área de Castellano</option>
            </select>
        </div>

        <div className="col-md-6">
            <label htmlFor="tipoPreguntasSelector">Tipo de Preguntas:</label>
            <select id="tipoPreguntasSelector" className="form-control" value={targetTipoPreguntas} onChange={handleTipoPreguntasChange} >
                <option value="#unclasified">Clasifica las preguntas que tendrá tu lectura</option>
                <option value="infiere_significado">Infiere significado</option>
                <option value="reflexiona_fcc">Reflexiona forma,contenido y contexto</option>
                <option value="recupera_informacion">Recupera información</option>
                <option value="razonamiento_logico">Razona Lógicamente</option>
                <option value="mixto">Mixto</option>
            </select>
        </div>
      </div>
      
      <div className="p-10 row">

        
        <div className="col-md-6">
            <label htmlFor="tipoMaterialEducativo">Tipo de Material Educativo:</label>
            <select id="tipoMaterialEducativo" className="form-control" value={targetTipoMaterialEducativo} onChange={handleTipoMaterialEducativo} >
                <option value="#unclasified">Clasifica tipo de material</option>
                <option value="pdfshortdocument">PDF corto 5 páginas o menos</option>
                <option value="pdfmediumdocument">PDF mediano 30 páginas o menos</option>
                <option value="pdflargedocument">PDF grande 30 páginas o más</option>
                <option value="videoyoutube_short">Video Youtube SHORT</option>
                <option value="videoyoutube_classic">Video Youtube CLASICO 16:9</option>
                <option value="videoyoutube">Video Youtube</option>
                <option value="videopinterest">Video Pinterest</option>
                <option value="videoinstagram">Video Instagram</option>
                <option value="videotiktok">Video TikTok</option>
                <option value="videofacebook">Video Facebook</option>
                <option value="videocanva">Video Canva</option>
                <option value="imagenilustrativa">Imagen Ilustrativa</option>
                <option value="simplelecture">Lectura Simple</option>
            </select>
        </div>

        <div className="col-md-6">
            <label htmlFor="linkdelmaterialREPO"  >Link del material Referencia Repositorio</label>
            <input id="linkdelmaterialREPO" className="form-control" placeholder="#link donde se encuentra el material"  value={targetLinkMaterialREPO} onChange={handleLinkRepoChange} >
            </input>
        </div>

        <div className="col-md-6">
            <label htmlFor="linkdelmaterialOFICIAL"  >Link del material Referencia Oficial</label>
            <input id="linkdelmaterialOFICIAL" className="form-control" placeholder="#link de donde fue publicado"  value={targetLinkMaterialOFICIAL} onChange={handleLinkOficialChange} >
            </input>
        </div>

        <div className="col-md-6">
            <label htmlFor="tipoSelectorNivelProfundidad">NIVEL Y PROFUNDIDAD DE LECTURA:</label>
            <select id="tipoSelectorNivelProfundidad" className="form-control" value={targetTipoSelectorNivelProfundidad} onChange={handleTipoSelectorNivelProfundidadChange} >
            <option value="#unclasified">Clasifica nivel de complejidad material</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
            </select>
        </div>


      </div>
    </div>
  );
}

export default ClasificadorLectura;
